import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon, CheckIcon } from 'lucide-react';
const BONUSES = [{
  number: 1,
  title: 'Diccionario de Versos: El Arsenal Verbal del Truco Argentino',
  desc: 'Las 100 frases listas para usar en cada situación de la mesa, sin pensar, sin improvisar, sin quedar como un nabo.',
  image: 'https://cdn.magicpatterns.com/uploads/ro5oGjh1dv3ghxqMh491rX/bono_1_truco-removebg-preview.png',
  bullets: ['Versos para el Envido, el Truco, el Retruco y el Vale Cuatro', 'Frases para irse al Mazo sin perder estatus', 'Cómo ganar sin caer mal y perder sin regalar lectura', 'Los versos para tiltear al rival sin generar quilombo', 'Tu guía personal de "12 versos de cabecera" lista para completar'],
  footer: 'Para que nunca más te quedes sin saber qué decir en el momento que más importa.'
}, {
  number: 2,
  title: 'Cheat Sheet de Señas: Código Rápido de Pareja',
  desc: 'La guía visual para jugar en pareja sin hablar y sin mandarte mocos. Lista para el celular y para imprimir.',
  image: 'https://cdn.magicpatterns.com/uploads/ojQUmiqGGkaJyoKQW1j3K1/bono_2_truco-removebg-preview.png',
  bullets: ['Las 6 señas esenciales con gesto exacto y significado', 'Las 6 señas avanzadas para parejas que quieren jugar fino', 'Árbol de decisión express para Envido y Truco en pareja', 'Protocolo pre-partida de 2 minutos para sincronizarse', 'Plan B legal sin señas para mesas con árbitro', 'Checklist de implementación en 10 minutos'],
  footer: 'Para que vos y tu compañero funcionen como uno solo desde la primera mano.'
}, {
  number: 3,
  title: 'Pack de Jugadas Sucias (Pero Legales)',
  desc: '20 jugadas listas con paso a paso, riesgo y ejemplo real para robar puntos con cabeza, no con suerte.',
  image: 'https://cdn.magicpatterns.com/uploads/4FWxLMq6ArMwN4vNseEfNX/bono_3_truco-removebg-preview.png',
  bullets: ['Jugadas para ganar aunque no ligues cartas', 'Tácticas de presión, timing y narrativa que el rival no puede anticipar', 'Las 5 jugadas para practicar primero y mejorar rápido', 'Escala de riesgo para cada jugada (verde, amarilla, roja)', 'Fichas individuales con objetivo, cuándo, cómo, riesgo y frase lista'],
  footer: 'Para que la próxima mesa sea diferente a todas las anteriores.'
}];
export function BonusSection() {
  return <section className="py-24 bg-truco-surface relative border-t border-truco-gold/10" data-id="element-13">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-14">
        <div className="text-center mb-16" data-id="element-15">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-truco-gold/20 mb-6" data-id="element-16">
            <GiftIcon className="w-8 h-8 text-truco-gold" data-id="element-17" />
          </div>
          <h2 className="text-4xl md:text-5xl font-heading font-black text-truco-cream mb-4" data-id="element-18">
            🎁 3 BONOS INCLUIDOS HOY
          </h2>
          <p className="text-xl text-truco-creamMuted" data-id="element-19">
            Complementos estratégicos para acelerar tus resultados.
          </p>
        </div>

        <div className="space-y-12" data-id="element-20">
          {BONUSES.map((bonus, index) => <motion.div key={bonus.number} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} className="bg-gradient-to-br from-truco-dark to-black border border-truco-gold/30 rounded-2xl p-8 md:p-10 shadow-2xl relative overflow-hidden" data-id="element-21">
              {/* Decorative background glow */}
              <div className="absolute top-0 right-0 w-64 h-64 bg-truco-gold/5 rounded-full blur-[80px] pointer-events-none" data-id="element-22" />

              <div className="grid md:grid-cols-12 gap-8 items-center relative z-10" data-id="element-23">
                <div className="md:col-span-8" data-id="element-24">
                  <div className="flex flex-wrap items-center gap-4 mb-4" data-id="element-25">
                    <h3 className="text-2xl font-heading font-bold text-truco-cream" data-id="element-26">
                      🎁 Bono #{bonus.number}
                    </h3>
                    <span className="bg-truco-gold text-truco-dark font-bold px-3 py-1 rounded-full text-sm uppercase tracking-wider animate-pulse" data-id="element-27">
                      Hoy GRATIS
                    </span>
                  </div>

                  <h4 className="text-xl font-bold text-truco-gold mb-4" data-id="element-28">
                    {bonus.title}
                  </h4>
                  <p className="text-truco-creamMuted mb-6" data-id="element-29">{bonus.desc}</p>

                  <ul className="space-y-3 mb-6" data-id="element-30">
                    {bonus.bullets.map((bullet, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-31">
                        <CheckIcon className="w-5 h-5 text-truco-gold shrink-0 mt-0.5" data-id="element-32" />
                        <span className="text-sm text-truco-cream" data-id="element-33">
                          {bullet}
                        </span>
                      </li>)}
                  </ul>

                  <p className="text-truco-cream font-medium italic border-l-2 border-truco-gold pl-4 py-1" data-id="element-34">
                    {bonus.footer}
                  </p>
                </div>

                <div className="md:col-span-4 flex justify-center" data-id="element-35">
                  <img src={bonus.image} alt={`Bono #${bonus.number} — ${bonus.title}`} className="w-full max-w-[220px] object-contain drop-shadow-[0_0_30px_rgba(212,168,83,0.2)]" data-id="element-36" />
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}